// Shared rules for treatment types (clinics/{id}/categories, type: "treatmentType").
// Used by the clinic-settings card, the booking-link settings panel, the
// appointment wizard and the public booking page so all of them read the
// optional public-booking fields the same way.

// Firestore may hold docs written before these fields existed, so every reader
// goes through this normalizer instead of trusting raw booleans.
export const normalizeTreatmentType = (t) => ({
  ...t,
  duration:
    t?.duration != null && Number(t.duration) > 0 ? Number(t.duration) : null,
  rate: t?.rate != null && t.rate !== "" ? Number(t.rate) : null,
  isPublic: t?.isPublic === true,
  showPrice: t?.showPrice === true,
  showDuration: t?.showDuration !== false,
});

// Mirrors the server-side exclusion rule in functions/bookingHelper.js:
// a public type without a duration (or with "show price" but no rate) is
// silently dropped from the booking page, so the settings UI warns about it.
export const getPublicTypeWarnings = (t) => {
  const type = normalizeTreatmentType(t || {});
  const warnings = [];
  if (type.isPublic && !type.duration) {
    warnings.push("חסר משך — לא יוצג בעמוד ההזמנה");
  }
  if (type.isPublic && type.showPrice && type.rate == null) {
    warnings.push("הצגת מחיר פעילה אך אין תעריף — לא יוצג בעמוד ההזמנה");
  }
  return warnings;
};

// True when the type would actually appear on the public booking page.
export const isBookableTreatmentType = (t) =>
  normalizeTreatmentType(t || {}).isPublic && getPublicTypeWarnings(t).length === 0;

export const DURATION_PRESETS = [30, 45, 50, 60, 90];

// Shared palette for treatment-type colors (also used by task/reminder
// categories in ClinicSettingsPage — keep in sync).
export const CATEGORY_COLORS = [
  "#3b82f6", // Blue
  "#22c55e", // Green
  "#f59e0b", // Orange
  "#ef4444", // Red
  "#8b5cf6", // Purple
  "#ec4899", // Pink
  "#06b6d4", // Cyan
  "#14b8a6", // Teal
  "#6366f1", // Indigo
  "#84cc16", // Lime
  "#f43f5e", // Rose
  "#6b7280", // Gray
];
